import React from "react";
import { Box, Stack, Text } from "@origin-digital/ods-core";
import { InteractiveBox } from "../InteractiveBox";
import { IconChevronRight } from "@origin-digital/ods-icons";
import { RequestBoxProps } from "./types";

export const RequestBox = ({
  primaryIcon = undefined,
  primaryText = "",
  secondaryIcon = undefined,
  secondaryText = "",
  summaryText = "",
  onClick = undefined,
  "data-id": dataId = "requestBox",
}: RequestBoxProps) => (
  <InteractiveBox
    padding="medium"
    borderRadius="xsmall"
    tabIndex={0}
    style={{
      cursor: "pointer",
      transition: "background-color 0.2s ease-in-out",
      outline: "none",
    }}
    onClick={onClick}
    data-id={`${dataId}.root`}
  >
    <Box display="flex" alignItems="flex-start" gap="medium">
      <Stack space="xsmall">
        {/* Service icon and address */}
        <Box display="flex" alignItems="flex-start" gap="small">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            // paddingTop="xxxsmall"
            data-id={`${dataId}.primaryIcon`}
          >
            {primaryIcon}
          </Box>
          <Text
            tone="neutral"
            weight="medium"
            data-id={`${dataId}.primaryText`}
          >
            {primaryText}
          </Text>
        </Box>
        {/* End email icon and email address */}

        {/* ID + Status */}
        <Stack space="xxsmall">
          {/* OC ID */}
          <Box display="flex" alignItems="center" gap="small">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ width: "24px", height: "24px" }}
              data-id={`${dataId}.secondaryIcon`}
            >
              {secondaryIcon}
            </Box>
            <Text tone="neutralLight" data-id={`${dataId}.secondaryText`}>
              {secondaryText}
            </Text>
          </Box>
          {/* End OC ID */}
          {/* Status */}
          <Box display="flex" alignItems="center" gap="small">
            <Box style={{ width: "24px", height: "24px" }} />
            <Text tone="neutralLight" data-id={`${dataId}.summaryText`}>
              {summaryText}
            </Text>
          </Box>
          {/* End Status */}
        </Stack>
        {/* End ID + Status */}
      </Stack>
      {/* Chevron */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingTop="xxxsmall"
      >
        <IconChevronRight color="grey300" size="xsmall" />
      </Box>
    </Box>
  </InteractiveBox>
);
